
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdminDashboard } from "../redux/adminDashboardThunk";

export default function useAdminDashboard() {
  const dispatch = useDispatch<any>();

  const { data, loading, error } = useSelector(
    (state: any) => state.adminDashboard
  );

  useEffect(() => {
    if (!data && !loading) {
      dispatch(fetchAdminDashboard());
    }
  }, [dispatch, data, loading]);

  const refetch = useCallback(() => {
    dispatch(fetchAdminDashboard({ force: true }));
  }, [dispatch]);

  return {
    data,
    loading,
    error,
    refetch,
  };
}
